import { useBrandfolderOptimizedImage } from '@/util/useBrandfolderOptimizedImage';

const imageStyles = { width: '100%', height: 'auto' };

type Props = {
  src: string;
  alt:string;
  className?:string;
  imageOptimization?:boolean
};

export const ImageComponent = ({
  src, alt, className, imageOptimization = true,
}:Props) => {
  const optimizedSrc = useBrandfolderOptimizedImage(src);

  return (
    <img
      src={imageOptimization ? optimizedSrc : src}
      alt={alt}
      loading="lazy"
      className={className}
      style={imageStyles}
    />
  );
};
